import {Expose, instanceToPlain} from 'class-transformer';
import {IsEnum, IsString} from 'class-validator';
import {Base64ImageType} from '../types/base64Image.type';

export class UserPortrait {
	@Expose()
	@IsString()
	image: string;

	@Expose()
	@IsEnum(Base64ImageType)
	imageType: Base64ImageType;

	constructor(init?: Partial<UserPortrait>) {
		if (init) {
			Object.assign(this, init);
		}
	}

	toJSON() {
		return instanceToPlain(this);
	}
}
